import script from "./CompanyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyHeader.vue?vue&type=script&setup=true&lang=js"

import "./CompanyHeader.vue?vue&type=style&index=0&id=590d9296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590d9296"]])

export default __exports__